import React from "react";
import { css } from "@emotion/core";
import { Desktop, Tablet } from "../../constants/responsive";

const MoveButton = ({ right = false, left = false }) => {
  return (
    <div>
      {right && (
        /* 向右移button绘制 */
        <div
          css={css`
            position: absolute;
            border-radius: 50%;
            background-color: #ffffff;
            -webkit-backdrop-filter: blur(30px);
            backdrop-filter: blur(30px);
            box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);
            ${Tablet} {
              width: 44px;
              height: 44px;
              padding: 13.5px 18.4px 13.7px 17.2px;
              right: 0px;
              transform: translate(-19px, -30px);
            }
            ${Desktop} {
              width: 67px;
              height: 67px;
              padding: 23.8px 29.5px 20.2px 18.5px;
              right: 0px;
              /* transform: translate(0px, -180px); */
            }
          `}
        >
          <div
            css={css`
              ${Tablet} {
                width: 14px;
                height: 3px;
                background-color: #000;
                transform: rotate(45deg);
                border-radius: 2px;
                margin-top: 2px;
              }
              ${Desktop} {
                width: 20px;
                height: 5px;
                background-color: #000;
                transform: rotate(45deg);
                border-radius: 5px;
                margin-left: 5px;
              }
            `}
          ></div>
          <div
            css={css`
              ${Tablet} {
                width: 14px;
                height: 3px;
                background-color: #000;
                transform: rotate(-45deg);
                border-radius: 2px;
                margin-top: 7px;
              }
              ${Desktop} {
                width: 20px;
                height: 5px;
                background-color: #000;
                transform: rotate(-45deg);
                margin-top: 8.5px;
                margin-left: 5px;
                border-radius: 5px;
              }
            `}
          ></div>
        </div>
      )}
      {left && (
        /* 向左移button绘制 */
        <div
          css={css`
            position: absolute;
            border-radius: 50%;

            background-color: #ffffff;
            -webkit-backdrop-filter: blur(30px);
            backdrop-filter: blur(30px);
            box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.16);

            ${Tablet} {
              width: 44px;
              height: 44px;
              padding: 13.5px 18.4px 13.7px 14.2px;
              transform: translate(-6px, -30px);
            }
            ${Desktop} {
              width: 67px;
              height: 67px;
              padding: 23.8px 29.5px 20.2px 18.5px;
              /* transform: translate(-10px, -180px); */
            }
          `}
        >
          <div
            css={css`
              ${Tablet} {
                width: 14px;
                height: 3px;
                background-color: #000;
                transform: rotate(-45deg);
                border-radius: 2px;
                margin-top: 2px;
              }
              ${Desktop} {
                width: 20px;
                height: 5px;
                background-color: #000;
                transform: rotate(-45deg);
                border-radius: 5px;
                margin-left: 5px;
              }
            `}
          ></div>
          <div
            css={css`
              ${Tablet} {
                width: 14px;
                height: 3px;
                background-color: #000;
                transform: rotate(45deg);
                border-radius: 2px;
                margin-top: 7px;
              }
              ${Desktop} {
                width: 20px;
                height: 5px;
                background-color: #000;
                transform: rotate(45deg);
                margin-top: 8.5px;
                margin-left: 5px;
                border-radius: 5px;
              }
            `}
          ></div>
        </div>
      )}
    </div>
  );
};

export default MoveButton;
